import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Initialize GA4 - Replace with your actual Measurement ID
// You can also use an environment variable: import.meta.env.VITE_GA_MEASUREMENT_ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; 

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 only once
    if (!window.ga4Initialized) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      window.ga4Initialized = true;
    }

    // Send pageview with path
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
};

// Add type definition for the global flag
declare global {
  interface Window {
    ga4Initialized: boolean;
  }
}
